AdvancedSelectFragment:
  remoteHelp: Specify the path to the option list, value and label.
  remoteHelpMore: Tutorial.
  remoteHelpText: |
    <b>SIMPLE EXAMPLE</b>

    The external source returns data in JSON format, for example:
    <pre>
    {
        "books": [
            {
                "author": "Herman Melville",
                "category": "fiction",
                "isbn": "0-553-21311-3",
                "price": 8.99,
                "title": "Moby Dick"
            },
            {
                "author": "J. R. R. Tolkien",
                "category": "fiction",
                "isbn": "0-395-19395-8",
                "price": 22.99,
                "title": "The Lord of the Rings"
            }
        ]
    }
    </pre>
    The list of options is always in an array, delimited by square brackets <code>[]</code>. Each option is delimited by curly braces <code>{}</code>.
    The list of options is always in an array, delimited by <code>[]</code>.
    <b>Path to options</b>: in this example, the list of options is in a key named <code>books</code>. The path to the options is therefore <code>books</code>. It is possible that the options array is directly at the "root" of the results, in which case we do not need to specify a path.
    <b>Path to the label</b>: in each option in the <code>books</code>, the path to the label is <code>title</code>. This is the title of each book, which will be displayed as an option in the dropdown list.
    <b>Path to value</b>: in each option, the path to the value is <code>isbn</code> in this example. The goal is to have a unique value for each element (if the label is already different for each element, you can put the path to the label in this option).

    <b>ADVANCED EXAMPLE</b>

    The external source can return data with more levels. In this case, use <code>.</code> to go down level by level, for example:
    <pre>
    {
        "store": {
            "books": [
                {
                    "isbn": "0-553-21311-3",
                    "metadata": {
                        "author": "Herman Melville",
                        "category": "fiction",
                        "title": "Moby Dick"
                    },
                    "price": 8.99,
                },
                {
                    "isbn": "0-395-19395-8",
                    "metadata": {
                        "author": "J. R. R. Tolkien",
                        "category": "fiction",
                        "title": "The Lord of the Rings"
                    },
                    "price": 22.99,
                }
            ]
        }
    }
    </pre>
    <b>Path to options</b>: <code>store.books</code>
    <b>Path to the label</b>: <code>metadata.title</code>
    <b>Path to value</b>: <code>isbn</code>
AdvancedSelect:
  noOptions: No options.
  sourceError: An error occurred, please try again.
  typeToSearch: Type to search.
  typeAtLeastNbChars: Type at least {{minChars}} characters.
AdvancedToComparePage:
  back: Back to list
  title: "🔱 Advanced comparison"
  description: Compare the answers of the different respondents (case sensitivity, typo, etc.) to avoid unnecessary iterations and proofreading
  empty: Fields to compare will appear here.
AudioPlayer:
  error:
    description: Error loading file
PDFViewer:
  error:
    description: PDF loading error
IframeViewer:
  error:
    description: Iframe wrong link
PdfOcrViewer:
  previousPage: Previous page
  nextPage: Next page
  unzoom: Unzoom
  zoom: Zoom
  rotateLeft: Rotate left
  selectedValueNotFound: Selected value not found amongst the available values
  forField: for the field
  error:
    description: Error loading file
BlockForm:
  block: Block
  name: Name of the block
  foldable: Retractable
  duplicable: Duplication allowed
  showIncrement: Display increment
  iterativeBackground: Tweak iterations
  maxRows: Max. Height
  rowsRange: Number of iterations
  color: Background color
  insertAfter: Insert after this block
  delete: Delete this block
BlockSortingRulesTemplate:
  addRule: "Add new rule"
  empty: "No rule for this group"
  error:
    duplicate: "This field is already in this rule"
    mustBeInBlock: 'This field must be in group "{{ block }}".'
ContributeCloseButtonTemplate:
  back: Back
  error: 'Error on free task "{{ message }}".'
  alert: "You have been operating on the task for more than {{ startedAt }}, are you still there? If you do not reply, the task will be released within 30 seconds."
  alertLabel: "Yes"
CertificationPage:
  published: Reference answer published.
ContributePage:
  backAction: Back to
  answerError:
    description: An error occurred while submitting your task. Please try again or contact our support.
  noTaskError:
    description: You took part in all the contributions on this project.
  noCertificationError:
    description: Vous answered at every questions of this certification.
ContributeDonePage:
  title: Registered contribution.
  quit: Quit
  newTask: New task
ContributeFormErrorModal:
  title: Validation errors
  description: There are validation errors on the form. Correct the errors below before resubmitting.
  button: Correct
  error: "Error #{{ count }}"
  rowError: "Error #{{ count }} (line #{{ row }})"
  forceValidation: I still want to confirm my answer.
AdvancedSelectField:
  placeholder: "Search and add."
DrawerContentBlocks:
  title: "Create a block"
  description: "Add a block to your form."
DrawerContentBlocksSortingPage:
  empty: "You have no group."
  title: "Groups sorting rules"
  description: "Select field group for comparison"
DrawerContentInfo:
  title: "Indication of realization."
  description: "Customize the instructions given to the operators to best carry out the project. Add a video, an image, or a link to a tutorial... They will be able to access it by clicking on "
DrawerContentQuality:
  title: "👋 Quality options."
  description: "Fix the form validation rules to obtain quality entries (also allows to manage the comparison options in the case of multiprocessing)"
DrawerContentRespondants:
  title: ""
  description: ""
DrawerIterationOverloadPage:
  title: Additional iterations
  description: Define the cases for which you want to have the answer validated by more respondents than the one configured. If the rules below are fulfilled, then one more respondent will be requested, even if the first ones agree among themselves
  newRule: New rule
  empty: Empty rule.
  newRuleLabel: Rule {{ count }}
DrawerContentStrategy:
  title: "🎯 Management of processing methods"
  description: "Customize the treatment process. In multiprocessing for example, each task is carried out by several operators and reviewed automatically to maximize the quality of the restitution"
DrawerContentNoCompare:
  title: ""
  description: "Fields not to compare"
DrawerContentToComparePage:
  title: Fields to compare together
  description: Add fields here to compare together.
  addRule: Add a rule
  empty: No rule
  duplicate: This field is already contained in the rule.
  mustBeInSameBlock: All fields in a rule must belong to the same group.
  invalidType: This type of field cannot be added to the rule.
DrawerContentSettings:
  title: "👌 Settings of your form."
  description: "Set the attributes of your form here."
DrawerFormControls:
  publish: Publish
  published: Published
  savePristine: Registered
  saveDirty: Save
  missingRequired: "The following fields are required to publish a form:."
  publishConfirm: Are you sure you want to publish your form?
DrawerContentValidation:
  title: 🤝 Validation rules
  description: Validate the consistency of the entries using comparison rules.
  newRule: New rule
  noRules: No rule
  newRuleName: "Rule #{{ count }}"
Dropdown:
  empty: (empty)
ContributeFormTemplate:
  addBlock: Add
  clearBlock: Remove all
  submit: Reply
  hideFailedExecution: "{{ count }} rule(s) could not be executed."
ContributeAnswerDetailTemplate:
  taskError: Erro
  task: "Task #"
  project: Project
  priority: Priority
  rate: Mark
  quality: Quality
  validate: Validation
DrawerHeaderTitlePage:
  unnamed: "(no name)."
QualityNavTemplate:
  advancedToCompare: Advanced Comparison
  validation: Validation rules
  respondents: Contributor
  strategy: Review strategy
  noCompare: Do not compare
  toCompare: Fields to compare together
  blocksSorting: Sorting groups
  keyboardShortcuts: Entry rules
  iterationOverload: Additional iteration
QualitySelectTemplate:
  respondents: Contributor
  strategy: Review strategy
EditFieldTemplate:
  createField: Create a new field
EditDataTemplate:
  createData: Create a new data field
EditPage:
  createButton: "New field"
  drawerTitle: "👋 Create your first field!."
  drawerDescription: "Drag and drop or double-click to add a field."
DataPage:
  createButton: "Data field"
  drawerTitle: "👋 Create your variable fields!."
  drawerDescription: "Drag and drop or double-click to add a field. Add variable fields in the next tab."
Form:
  uniqueID: Identifier
  label: Label
  edit: edit
  create: create
FormulaInput:
  prompt:
    LITERAL_DATE: "Enter a valid date in the format (yyyy-mm-dd)"
    LITERAL_STRING: "It mus be a character :"
    LITERAL_NUMBER: "It must be an integer :"
FormulaField:
  invalidSyntax: Syntaxe Invalide
FormulaToken:
  sumOf: "SUM of"
  countOf: "NUMBER of"
  forEach: "For all"
  forEachIter: "For everyone"
  forAll: "For the form"
HideRuleFragment:
  enabled: Hide if
  error:
    selfReference: A field cannot reference itself.
    subFieldReference: A block cannot reference a child control.
    forbidden: You can't reference on this field
InfoPage:
  title: Design guidelines
IterationOverloadRule:
  minMatch: Iterations to validate
  formulaPlaceholder: Simple comparison
  instructions: Add a simple comparison rule with one field and one fixed value.
  deliveryAnswer: Choice of delivery
  errors:
    alreadyContained: This field is already referenced.
    wrongType: This type of field is not accepted.
    isMulti: The selected field must be configured in "Simple answer" mode
KeyboardShortcutsForm:
  key: 'Key "{{ key }}"'
  addShortcut: Add shortcut
  addMultiShortcut: Add choice shortcut
  value: Valeur
  noName: "No Name #{{ i }}"
  mcq:
    multiMode:
      set: Set
      unset: Unset
      toggle: Toggle
  select:
    multiMode:
      set: Select
      unset: Deselect
      toggle: Toggle
MCQ:
  other: Other
NoCompare:
  placeholder: Click on a field to add it ...
RangeField:
  min: Min
  max: Max
SettingsForm:
  averageDuration: Average time
  minimumDuration: Minimum time
  keySkill: Key competence
  subdivide: Lotir
  submitLabel: Validate button
  allowError: Allow error validation
  enterToValidate: Enter to submit
  prefillInputs: Pre-fill input fields
  showFormTitle: Add form title on task
  fontSize: Font size
  disableBrowserShortcuts: Disable browser Shortcuts
  gridSize: Grid Size
ShortcutFragment:
  shortcut: Shortcut
PreviewPage:
  back: Back
UploadInput:
  openDialog: Parcourir
  pending: Downloading  ...
  uploadFailed: "File upload failed : {{ message }}"
  errors:
    belowMin: "Minimum allowed {{ size }}mo."
    aboveMax: "Maximum allowed {{ size }}mo."
QualityStrategyForm:
  answerMultiOptions:
    true: Send the best answer
    false: Send all answer
  answerProofReadingOptions:
    allAnswer: Send the best answer
    lastAnswers: Send answer from the last review
  bestAnswerOnly: Send the best answer
  samplePercent: Smart Sample
  matchingCount: Number of matches
  iterationCount: Iterations Max.
  indeterminateMode: If indeterminate
  respondentPerTask: Respondents / Task
  proofreadingCount: Number of proofreads
  readerInstructions: Proofreading Instructions
  sendingAnswer: Send answer
  topOptions:
    panel: Panel
    multi: Multi-Processing
    proofreading: Proofreading
    simple: Simple Entry
  isComplex:
    left: Simple entry
    right: Other options
  sampleOptions:
    sample: Sample
    multi: Multi
  undeterminateOptions:
    bestAnswer: Best Answer
    manual: Manual
RegexRuleFragment:
  regex: Regular expression
  errorMessage: Error message
  regexHelp: Test your regex
  regexHelpLink: regex101.com
ValidationRule:
  executeWhenHidden: Execute even if the fields are hidden
  formulaPlaceholder: Formula ...
  errorMessage: Error message
  errorMessagePlaceholder: The value is incorrect.
ViewerFragment:
  error:
    fixedModeItemsBelow: Remove the boxes under the viewer to enable docked mode.
Copy: Copy
WasCopied: Copied!

# Keys linked to fields typology
field:
  options:
    information: Information
    required: Mandatory
    charsRange: Number of characters
    wordsRange: Number of words
    allowedDecimals: Integer / Decimals
    integer: Whole
    decimals: Decimals
    optionalUnit: Optional unit
    valueRange: Values
    longitudeRange: Size of the longitude
    latitudeRange: Latitude size
    values: Values
    selectTypology: Type
    domains_accepted: Accepted domains
    domains_rejected: Rejected domains
    multi: Several answers possible
    allowOther: Choice "Other" is possible
    autoselect: Preselect 1st value
    activateLabelValue: Activate values
    injectSeparatorValueLabel: Separator label value
    separatorData: Data separator
    Errorseparator: Use separator
    labelValuePlaceholder: LABEL_1@@VALUE_1 \n LABEL_2@@VALUE_2 LABEL_3@@VALUE_3
    rib: RIB
    horizontal: Horizontal display
    choices: Choice
    whitelist: Whitelist
    blacklist: Blacklist
    datetimeFormat: Date & time format
    capitalized: Capital letter at the beginning of a word
    injectChoices: Choices as data
    timeRange: Hours min & max
    dateRange: Min & max dates
    onlyCountry: Country only
    defaultFrance: Default France
    allowedExtentions: Authorized extensions
    imagesOnly: Image file
    sizeRange: File size (MB)
    options:
      date: Date
      time: Time
      datetime: Date & Time
    remoteOptionsEnabled: External source
    remoteOptions:
      url: Stream URL
      authorization: HTTP Authorization
      pathOptions: Path to options
      pathLabel: Path to the label
      pathValue: Path to value
      addSupplierIDInHeaders: Add id to header
      queryMode: Search mode
      queryModeInstructions: Allows a dynamic search mode on the external source. The {query} element in the URL will be replaced by the entered text.
      minChars: Minimum characters
    hideRich: Hide Rich Text
  text_short:
    label: Short text
  email:
    label: E-mail
  coordinates_gps:
    label: GPS coordinates
  number:
    label: Number
  mcq:
    label: MCQ & QCU
  phonenumber:
    label: Phone number
  text:
    label: Text
  url:
    label: Link
  select:
    label: Dropdown list
  datetime:
    label: Date
  address:
    label: Address
  file:
    label: Upload document
  rib:
    label: IBAN/RIB

# Keys linked to fields data
data:
  options:
    content: Content
    link: Link
    information: Information
    fixedMode: Anchored mode
    perserveHeight: Preserve height
    perserveWidth: Preserve length
  data_text:
    label: Text
    numeric: "Numerical comparison"
  data_numeric:
    label: "Text"
  data_embed:
    label: Viewer
  data_url:
    label: Formatted link
  data_video:
    label: Video
  data_audio:
    label: Audio
  data_image:
    label: Image
  data_iframe:
    label: Iframe
  data_pdf_ocr:
    label: PDF OCR

comparisonRules:
  options:
    case_sensitive: Case sensitive
    space_sensitive: Spaces sensitive
    special_char_sensitive: Special characters sensitive
    accent_sensitive: Accents sensitive
    distance: Difference
    deliveryAnswer: Response to send
    timeunit: Time unit
    options:
      1: "Best Reenactment"
      2: "Normalized Response"
      3: "All iterations"
      4: "All iterations matching the minimum required iterations"
      5: "All iterations matching at least 2 times"
      6: "Average / Middle"
      7: "Best Contributor"
      8: "Best answer validating the condition(s)"
      9: "Empty"
      second: Second
      minute: Minute
      hour: Hour
      day: Day
      month: Month
      year: Year

error:
  default:
    title: "An error has occurred"
    body: "Please try again in a few moments."

# Keys linked to FieldError
FieldError:
  required: "This field is required."
  not_enough_chars: "Not enough characters (min {{ value }})."
  too_many_chars: "Too many characters (max {{ value }})"
  not_enough_words: "Not enough words (min {{ value }})"
  below_minimum: "The value is too small (min {{ value }})."
  above_maximum: "The value is too large (max {{ value }})."
  too_many_words: "Too many words (max {{ value }})."
  not_integer: "The {{ value }} value is not an integer."
  not_number: "The {{ value }} value is not a number."
  denied_domains: "The domain {{ value }} is not allowed."
  bad_format_email: "The format of the email address is invalid."
  bad_format_phone: "The format of the phone number is invalid."
  time_below_minimum: "The time cannot be less than {{ value }}."
  time_above_maximum: "The time cannot be greater than {{ value }}."
  date_below_minimum: "The date cannot be less than {{ value }}."
  date_above_maximum: "The date cannot be greater than {{ value }}."
  bad_format_url: "This is not a valid URL."
  invalid_address: "The postal address is invalid."
  regex_not_match: "The value must respect the format {{ value }}"
  invalid_syntax: "Invalid syntax."
  iteration_rule_syntax_invalid: "The format must respect <field> <operator> <value>."
  not_capitalized: "The value must have a capital letter at the beginning of each word."
  below_min_rows: "Requires at least {{ value }} line(s)."
  above_max_rows: "Requires at most {{ value }} line(s)."
  below_min_choices: "Requires at least {{ value }} choices."
  above_max_choices: "Requires at most {{ value }} choices."
  invalid_rib: "invalid IBAN"
  invalid_date: 'invalid Date'

form:
  errors:
    title: Form title
    errorChoicesSelectorMcq: Wrong syntax in selector or qcm choices
    averageDuration: Settings > Average Duration
    minimumDuration: Settings > Maximum Duration
    respondentPerTask: Quality > Respondents by task
    missingBlockSortingRules: 'The group "{{block}}" does not have a sort rule'
    iterationOverloadOutOfRange: 'The "Iteration" parameter of the additional overload rule "{{ rule }}" is outside the range of iterations defined in the quality strategy.'

popover:
  anchorEdit:
    title: Response fields
    text: "Add the fields you want entered: Text, Date, Address, etc."
    svg: undraw_approve
  anchorReload:
    title: Documents to enter
    text: "Add the documents and information that you will make available to operators to make their entries: pdf, images, videos, text, etc."
    svg: undraw_collection
  anchorBlocks:
    title: Creating groups
    text: Group certain fields together to simplify multiple or repetitive entries.
    svg: undraw_content
  anchorInfo:
    title: Additional Info
    text: Give all the useful information to the operators to help them during the entry.
    svg: undraw_reviewed
  anchorStrategy:
    title: Review strategy
    text: Determine how your tasks are processed to ensure optimal quality (multiprocessing, proofreading, sampling, etc.)
    svg: undraw_Taking_notes
  anchorQuality:
    title: "Quality options"
    text: "Set the form validation rules to obtain quality inputs (also allows you to manage the comparison options in the case of multiprocessing)"
    svg: undraw_update
  anchorSettings:
    title: General settings
    text: Set the minimum and maximum times allowed here, customize the validation button, etc.
    svg: undraw_preferences

toast:
  compare: This field is referenced in the fields to compare together / do not compare
  hideIf: This field is referenced in the form validation rule
  sorting: "This field is referenced in the sorting rule for group {{sortingName}}"
  rule: This field is referenced in the conditional hide rule of field {{fieldName}}
regex:
  enabled: Regex validation
